import gql from 'graphql-tag';

const getPrintProduct = gql`
  query getPrintProduct($print_product_id: RecordID!) {
    printProducts(print_product_id: $print_product_id) {
      records {
        id
        name
        card {
          id
        }
        sizes {
          total
          records {
            id
            orientations
            print_size {
              id
              name
              width
              height
            }
            mounts {
              total
              records {
                id
                print_product_size {
                  print_size {
                    id
                    name
                    width
                    height
                  }
                }
                print_mount {
                  id
                  name
                }
                price {
                  value
                  currency
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default getPrintProduct;
